<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Bevételezések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/processes/inward-handlings/add')"
        icon="el-icon-plus"
        v-can="'inwardhandling.create'"
      >
        Új bevételezés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="inwardHandling/fetchAll"
      />
    </div>
    <inward-handling-list
      @show-customer-order-dialog="showCustomerOrderDialog"
      @show-representative-order-dialog="showRepresentativeOrderDialog"
    />
    <template v-if="$route.meta.showAddInwardHandlingDialog">
      <inward-handling-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateInwardHandlingDialog">
      <inward-handling-dialog
        :inward-handling-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showInwardHandlingViewDialog">
      <inward-handling-dialog
        :inward-handling-id="$route.params.id"
        type="view"
      />
    </template>

    <!-- Customer Order Dialog -->
    <customer-order-dialog
      v-if="customerOrderDialogVisible"
      :inward-handling-id="selectedInwardHandlingId"
      @close="customerOrderDialogVisible = false"
    />

    <!-- Representative Order Dialog -->
    <representative-order-dialog
      v-if="representativeOrderDialogVisible"
      :inward-handling-id="selectedInwardHandlingId"
      @close="representativeOrderDialogVisible = false"
    />
  </el-card>
</template>

<script>
import InwardHandlingList from '../../components/processes/inwardHandlings/List';
import InwardHandlingDialog from '../../components/processes/inwardHandlings/Dialog';
import CustomerOrderDialog from '../../components/processes/inwardHandlings/CustomerOrderDialog';
import RepresentativeOrderDialog from '../../components/processes/inwardHandlings/RepresentativeOrderDialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    InwardHandlingList,
    InwardHandlingDialog,
    CustomerOrderDialog,
    RepresentativeOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
      customerOrderDialogVisible: false,
      representativeOrderDialogVisible: false,
      selectedInwardHandlingId: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    showCustomerOrderDialog(inwardHandlingId) {
      this.selectedInwardHandlingId = inwardHandlingId;
      this.customerOrderDialogVisible = true;
    },
    showRepresentativeOrderDialog(inwardHandlingId) {
      this.selectedInwardHandlingId = inwardHandlingId;
      this.representativeOrderDialogVisible = true;
    },
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'cm_delivery_note_number',
          label: 'CM szlev száma',
        },
        {
          type: 'text',
          name: 'reference_number',
          label: 'Hivatkozási szám',
        },
        {
          type: 'text',
          name: 'comment',
          label: 'Megjegyzés',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Kész',
              status: 'done'
            },
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Igen',
              is_stockist: 1,
            },
            {
              label: 'Nem',
              is_stockist: 0,
            },
          ],
          name: 'is_stockist',
          label: 'Besz. ár végleges',
          labelCallback: status => status.label,
          valueKey: 'is_stockist',
        },
        {
          type: 'remote',
          name: 'supplier_id',
          label: 'Beszállító',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'select',
          options: storages,
          name: 'storage_id',
          label: 'Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
